<template>
  <div class="flex flex-wrap mb-2" :style="(guideStep >= 51 && guideStep <= 57) || guideStep == 501 || guideStep == 503 || guideStep == 11001 || guideStep == 11002 ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-full lg:w-3/4 flex-1 min-w-0 bg-white rounded-xl space-y-6 p-3 lg:p-6" style="position:relative">
      <loading :active="!showMaterialMyside"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="false"
              :color="'#fff'"
              :background-color="'#000'"
              :opacity="'0.8'"
              :loader=" dots">
      </loading>
      <div>
        <span v-if="goalsObjectiveData == 'MESSAGES'" class="text-red-500 text-sm">*</span>
        <span v-if="goalsObjectiveData != 'MESSAGES'" class="text-grap-700 align-middle">{{lang['components']['Event']['Material']['title']}}</span>
        <span v-if="goalsObjectiveData == 'MESSAGES'" class="text-grap-700 align-middle">{{lang['components']['Event']['Material']['message_title']}}</span>
        <button
          v-if="!editPageType"
          id="material"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['Material']['video_teaching']}}
        </button>
        <i
          v-if="goalsObjectiveData == 'MESSAGES'"
          class="pi pi-exclamation-circle align-middle text-gray-300 ml-2 leading-relaxed"
          v-tooltip="`${lang['components']['Event']['Material']['message_title_info']}`"
        ></i>
      </div>
      <div class="flex-1 space-y-4">
        <div v-if="!efficientAi" class="space-y-2" :class="{ 'ring-4 border-blue-400': guideStep === 11001 }">
          <div class="flex">
            <div class="leading-relaxed">
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Material']['optimize_title']}}</span>
            </div>
            <div class="text-grap-700 text-sm ml-2 mt-1">
              <InputSwitch v-model="viewDatalistData.creative_optimize" :disabled="viewDatalistData.disabled_creative_optimize" class="-my-1" />
              <span class="mx-1">{{lang['components']['Event']['Material']['optimize_switch']}}</span>
            </div>
            <i
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2 leading-relaxed"
              v-tooltip="`${lang['components']['Event']['Material']['optimize_info']}`"
            ></i>
          </div>
        </div>
        <div class="space-y-2 pb-8">
          <div>
            <span v-if="goalsObjectiveData != 'MESSAGES'" class="text-red-500 text-sm">*</span>
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Material']['ad_content_title']}}</span>
            <i
              v-if="goalsObjectiveData != 'MESSAGES'"
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
              v-tooltip="`${lang['components']['Event']['Material']['title_info']}`"
            ></i>
          </div>
          <div v-if="this.goalsObjectiveData != 'PRODUCT_CATALOG_SALES'">
            <span v-if="(!efficientAi && editPageType) || (efficientAi && !editPageType) || (!efficientAi && !editPageType)">
              <button
                v-if="goalsObjectiveData != 'MESSAGES'"
                class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1"
                @click="add_test()"
              >
                <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                {{lang['components']['Event']['Material']['add_ad_text']}}
              </button>
              <!-- 新手教學 -->
              <button
                v-if="goalsObjectiveData == 'MESSAGES'"
                class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1"
                @click="add_test()"
              >
                <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                {{lang['components']['Event']['Material']['add_ad_text']}}
              </button>
              <button
                v-if="optimizationAction != 'PAGE_LIKES' && goalsObjectiveData != 'LEAD_GENERATION'"
                class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1 ml-4"
                :class="{ 'ring-4 border-blue-400': guideStep === 52 }"
                @click="posts_data()"
              >
                {{lang['components']['Event']['Material']['posts_data_text']}}
              </button>
              <button
                class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1 ml-4"
                @click="creatives_data()"
              >
                {{lang['components']['Event']['Material']['creatives_data']}}
              </button>
            </span>
          </div>
          <div v-if="this.goalsObjectiveData == 'PRODUCT_CATALOG_SALES'">
            <button
              class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1"
              :class="{ 'ring-4 border-blue-400': guideStep === 501 }"
              @click="adset_ads_data()"
            >
              {{lang['components']['Event']['Material']['adset_ads']}}
            </button>
          </div>
          <!-- 新手教學 -->
          <div class="flex flex-col space-y-2 h-96 overflow-y-auto" :class="{ 'ring-4 border-blue-400': guideStep === 57 }">
            <!-- <div
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-blue-400"
              :class="{ 'border-blue-400': item.checked }"
              v-for="(item, index) in items"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_focus(item.content)"
            > -->
            <div
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in viewDatalistData.select_article"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5 }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_focus(item.content)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">FaceBook Post</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">FaceBook Post</span> -->
                    </div>
                  </div>
                </div>
                <i
                  v-if="item.tagType != 5"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_list(index)"
                ></i>
              </div>
            </div>

            <div
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in viewDatalistData.delete_article"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5 }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_focus(item.content)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">FaceBook Post</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">FaceBook Post</span> -->
                    </div>
                  </div>
                </div>
                <i
                  v-if="item.tagType == 1"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_delete_list(index)"
                ></i>
                <i
                  v-if="item.tagType == 2"
                  class="absolute top-2 right-2 pi pi-undo cursor-pointer"
                  @click="back_item(index)"
                ></i>
              </div>
            </div>

            <!-- <div
              v-for="(item, index) in viewDatalistData.select_creatives"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-blue-400"
              :class="{'status-n': item.status == 'N'}"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_creatives_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            > -->
            <div
              v-if="goalsObjectiveData != 'MESSAGES'"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in viewDatalistData.select_creatives"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_creatives_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['creatives_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告貼文</span> -->
                    </div>
                  </div>
                </div>

                <i
                  v-if="item.status == 'N'"
                  class="absolute top-2 right-8 pi pi-pencil cursor-pointer"
                  @click="edit_creatives_list(index)"
                ></i>
                <i
                  v-if="item.tagType != 5"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_creatives_list(index)"
                ></i>
              </div>
            </div>

            <div
              v-if="goalsObjectiveData != 'MESSAGES'"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in viewDatalistData.delete_creatives"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_creatives_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['creatives_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告貼文</span> -->
                    </div>
                  </div>
                </div>
                <i
                  v-if="item.tagType == 1"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_delete_creatives_list(index)"
                ></i>
                <i
                  v-if="item.tagType == 2"
                  class="absolute top-2 right-2 pi pi-undo cursor-pointer"
                  @click="back_creatives_item(index)"
                ></i>
              </div>
            </div>

            <div
              v-if="goalsObjectiveData == 'MESSAGES'"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in viewDatalistData.select_creatives_message"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_creatives_message_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['creatives_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告貼文</span> -->
                    </div>
                  </div>
                </div>
                <i
                  v-if="item.status == 'N'"
                  class="absolute top-2 right-8 pi pi-pencil cursor-pointer"
                  @click="edit_creatives_message_list(index)"
                ></i>
                <i
                  v-if="item.tagType != 5"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_creatives_message_list(index)"
                ></i>
              </div>
            </div>

            <div
              v-if="goalsObjectiveData == 'MESSAGES'"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in viewDatalistData.delete_creatives_message"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_creatives_message_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['creatives_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告貼文</span> -->
                    </div>
                  </div>
                </div>
                <i
                  v-if="item.tagType == 1"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_delete_creatives_message_list(index)"
                ></i>
                <i
                  v-if="item.tagType == 2"
                  class="absolute top-2 right-2 pi pi-undo cursor-pointer"
                  @click="back_creatives_message_item(index)"
                ></i>
              </div>
            </div>

            <div
              v-if="goalsObjectiveData == 'MESSAGES'"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in viewDatalistData.select_creatives_adset_ads_message"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_adset_ads_message_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['adset_ads_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告</span> -->
                    </div>
                  </div>
                </div>
                <i
                  v-if="item.tagType != 5"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_adset_ads_message_list(index)"
                ></i>
              </div>
            </div>

            <div
              v-if="goalsObjectiveData == 'MESSAGES'"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in viewDatalistData.delete_adset_ads_message"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_adset_ads_message_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['adset_ads_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告</span> -->
                    </div>
                  </div>
                </div>
                <i
                  v-if="item.tagType == 1"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_delete_adset_ads_message_list(index)"
                ></i>
                <i
                  v-if="item.tagType == 2"
                  class="absolute top-2 right-2 pi pi-undo cursor-pointer"
                  @click="back_adset_ads_message_item(index)"
                ></i>
              </div>
            </div>

            <!-- <div
              v-for="(item, index) in viewDatalistData.select_creatives_adset_ads"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-blue-400"
              :class="{'status-n': item.status == 'N'}"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_adset_ads_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            > -->
            <div
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in viewDatalistData.select_creatives_adset_ads"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_adset_ads_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['adset_ads_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告貼文</span> -->
                    </div>
                  </div>
                </div>
                <i
                  v-if="item.tagType != 5"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_adset_ads_list(index)"
                ></i>
              </div>
            </div>

            <div
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in viewDatalistData.delete_creatives_adset_ads"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_adset_ads_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['adset_ads_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告貼文</span> -->
                    </div>
                  </div>
                </div>
                <i
                  v-if="item.tagType == 1"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_delete_adset_ads_list(index)"
                ></i>
                <i
                  v-if="item.tagType == 2"
                  class="absolute top-2 right-2 pi pi-undo cursor-pointer"
                  @click="back_adset_ads_item(index)"
                ></i>
              </div>
            </div>



          </div>
        </div>
      </div>
      <!-- <SelectPostDialog v-bind:viewDatalist="postsData" v-model:show="showModal" ref="selected_items" /> -->
      <AddMaterial v-bind:pageId="this.pageIdData" v-bind:goalsObjectiveData="this.goalsObjectiveData" v-bind:lang="lang" v-model:showAdd="showAddModal" v-model:campaignId="this.campaignIdData" v-model:creativesDatalist="creativesItems" v-model:prviewCreativesDatalist="prview_creatives" v-model:creativesMessageDatalist="creativesMessageItems" v-model:prviewCreativesMessageDatalist="prview_creatives_message" @childAddMaterial="materialCreativesGetData" />
      <EditMaterial v-bind:pageId="this.pageIdData" v-bind:goalsObjectiveData="this.goalsObjectiveData" v-bind:lang="lang" v-model:showAdd="showEditModal" v-bind:creativeDataId="editCreativeId" v-model:creativesDatalist="creativesItems" v-model:prviewCreativesDatalist="prview_creatives" v-model:creativesMessageDatalist="creativesMessageItems" v-model:prviewCreativesMessageDatalist="prview_creatives_message" @childAddMaterial="materialCreativesGetData" />
      <SelectPostDialog :guideStep="guideStep" v-bind:viewDatalist="postsData" v-bind:pageId="this.pageIdData" v-bind:lang="lang" v-bind:specialAdCategory="this.viewDatalistData.special_ad_category" v-bind:selectStatus="selectStatus" v-model:itemsDatalist="items" v-model:prviewDatalist="prview" v-model:show="showModal" v-bind:goalsObjectiveData="this.goalsObjectiveData" v-model:adsetAdsDatalist="adsetAdsItems" v-model:prviewAdsetAdsDatalist="prview_adset_ads" v-model:adsetAdsMessageDatalist="creativesAdsetAdsMessageItems" v-model:prviewAdsetAdsMessageDatalist="prview_adset_ads_message" v-model:showList="showList" @childMaterialGetData="materialGetData" @childEmptyStep="emptyStep" />
      <SelectCreativeDialog :guideStep="guideStep" v-bind:viewDatalist="creativesData" v-bind:pageId="this.pageIdData" v-bind:goalsObjectiveData="this.goalsObjectiveData" v-bind:lang="lang" v-bind:specialAdCategory="this.viewDatalistData.special_ad_category" v-model:creativesDatalist="creativesItems" v-model:prviewCreativesDatalist="prview_creatives" v-model:creativesMessageDatalist="creativesMessageItems" v-model:prviewCreativesMessageDatalist="prview_creatives_message" v-model:showCreative="showCreativeModal" v-model:showCreativeDialogMyside="showCreativeDialogMyside" @childCreativesMaterialGetData="materialCreativesGetData" />
      <SelectAdsetAdsDialog :guideStep="guideStep" v-bind:viewDatalist="adaccountCampaignsData" v-bind:pageId="this.pageIdData" v-bind:goalsObjectiveData="this.goalsObjectiveData" v-bind:lang="lang" v-bind:specialAdCategory="this.viewDatalistData.special_ad_category" v-model:adsetAdsDatalist="adsetAdsItems" v-model:prviewAdsetAdsDatalist="prview_adset_ads" v-model:showAdsetAds="showAdsetAdsModal" @childAdsetAdsMaterialGetData="materialAdsetAdsGetData" />
    </div>

    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar">
      <div class="flex flex-col bg-white rounded-xl space-y-2 p-4">
        <div v-html="prview_now" v-if="prview_now"></div>
        <div v-html="prview_creatives_now" v-if="prview_creatives_now"></div>
        <div v-html="prview_creatives_message_now" v-if="prview_creatives_message_now"></div>
        <div v-html="prview_adset_ads_message_now" v-if="prview_adset_ads_message_now"></div>
        <div v-html="prview_adset_ads_now" v-if="prview_adset_ads_now"></div>
      </div>
    </div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
import InputSwitch from 'primevue/inputswitch';
import AddMaterial from "@/components/Event/AddMaterial.vue";
import EditMaterial from "@/components/Event/EditMaterial.vue";
import SelectAdsetAdsDialog from "@/components/Dialog/SelectAdsetAdsDialog.vue";
import SelectCreativeDialog from "@/components/Dialog/SelectCreativeDialog.vue";
import SelectPostDialog from "@/components/Dialog/SelectPostDialog.vue";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import Vue3DraggableResizable from 'vue3-draggable-resizable'
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
import axios from 'axios'
import Qs from 'qs'

export default {
  name: "Material",
  components: {
    InputSwitch,
    AddMaterial,
    EditMaterial,
    SelectAdsetAdsDialog,
    SelectCreativeDialog,
    SelectPostDialog,
    Loading
  },
  props: {
    // <!-- 新手教學 -->
    guideStep: {
      type: Number,
      default: -1
    },
    // <!-- 新手教學 -->
    editPage: {
      type: Boolean
    },
    viewDatalist: {
      type: Object
    },
    pageId: {
      type:String
    },
    goalsObjective:{
      type:String
    },
    campaignId: {
      type:String
    },
    campaign_objective:{
      type:String
    },
    selectStatus: {
      type: Boolean
    },
    lang: {
      type: Object
    },
    youtubeClose: {
      type: Boolean
    },
    efficientAi: {
      type: Boolean
    }
  },
  data() {
    return {
      useStatus: false,
      showMaterialMyside: true,
      showModal: false,
      showList: false,
      showAdsetAdsModal: false,
      showCreativeModal: false,
      showCreativeDialogMyside: false,
      showAddModal: false,
      showEditModal: false,
      editCreativesData: [],
      postsData: null,
      creativesData: null,
      adaccountCampaignsData: null,
      prviewHtml: [],
      selectObjective:null,
      items: [],
      itemsCount: 0,
      itemsDelete: [],
      itemsDeleteCount: 0,
      creativesItems: [],
      creativesItemsCount: 0,
      creativesItemsDelete: [],
      creativesItemsDeleteCount: 0,
      creativesMessageItems: [],
      creativesMessageItemsCount: 0,
      creativesMessageItemsDelete: [],
      creativesMessageItemsDeleteCount: 0,
      creativesAdsetAdsMessageItems: [],
      creativesAdsetAdsMessageItemsCount: 0,
      creativesAdsetAdsMessageItemsDelete: [],
      creativesAdsetAdsMessageItemsDeleteCount: 0,
      adsetAdsItems: [],
      adsetAdsItemsCount: 0,
      adsetAdsItemsDelete: [],
      adsetAdsItemsDeleteCount: 0,
      allCount: 0,
      prview: [],
      prview_post_list: [],
      prview_creatives: [],
      prview_creatives_list: [],
      prview_creatives_message: [],
      prview_creatives_message_list: [],
      prview_adset_ads_message: [],
      prview_adset_ads_message_list: [],
      prview_adset_ads: [],
      prview_adset_ads_list: [],
      prview_now: null,
      prview_creatives_now: null,
      prview_creatives_message_now: null,
      prview_adset_ads_message_now: null,
      prview_adset_ads_now: null,
      x: 0,
      y: 0,
      h: 200,
      w: 320,
      active: false,
      src: "https://www.youtube.com/watch?v=3wGiBNSfa8E",
      vars: {
        rel: 0,
        start: 0,
        end: 0,
      },
      view_youtube: false,
      // items: [
      //   {
      //     title: "貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱",
      //     content: "43789578977",
      //     date: "2021/07/09",
      //     imgSrc: "http://placehold.it/100x100",
      //     checked: false,
      //     great: 123,
      //     heart: 12,
      //     smile: 12,
      //     cry: 12,
      //     shock: 12,
      //     angry: 12
      //   },
      //   {
      //     title: "貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱",
      //     content: "43789578977",
      //     date: "2021/07/09",
      //     imgSrc: "http://placehold.it/200x200",
      //     checked: false,
      //     great: 123,
      //     heart: 12,
      //     smile: 12,
      //     cry: 12,
      //     shock: 12,
      //     angry: 12
      //   },
      //   {
      //     title: "貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱",
      //     content: "43789578977",
      //     date: "2021/07/09",
      //     imgSrc: "http://placehold.it/300x300",
      //     checked: false,
      //     great: 123,
      //     heart: 12,
      //     smile: 12,
      //     cry: 12,
      //     shock: 12,
      //     angry: 12
      //   },
      //   {
      //     title: "貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱",
      //     content: "43789578977",
      //     date: "2021/07/09",
      //     imgSrc: "http://placehold.it/300x300",
      //     checked: false,
      //     great: 123,
      //     heart: 12,
      //     smile: 12,
      //     cry: 12,
      //     shock: 12,
      //     angry: 12
      //   },
      //   {
      //     title: "貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱",
      //     content: "43789578977",
      //     date: "2021/07/09",
      //     imgSrc: "http://placehold.it/300x300",
      //     checked: false,
      //     great: 123,
      //     heart: 12,
      //     smile: 12,
      //     cry: 12,
      //     shock: 12,
      //     angry: 12
      //   },
      //   {
      //     title: "貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱",
      //     content: "43789578977",
      //     date: "2021/07/09",
      //     imgSrc: "http://placehold.it/300x300",
      //     checked: false,
      //     great: 123,
      //     heart: 12,
      //     smile: 12,
      //     cry: 12,
      //     shock: 12,
      //     angry: 12
      //   },
      //   {
      //     title: "貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱貼文名稱",
      //     content: "43789578977",
      //     date: "2021/07/09",
      //     imgSrc: "http://placehold.it/400x400",
      //     checked: false,
      //     great: 123,
      //     heart: 12,
      //     smile: 12,
      //     cry: 12,
      //     shock: 12,
      //     angry: 12
      //   }
      // ]
    };
  },
  // watch: {
  //     'items': {
  //         handler: function (after, before) {
  //             // Changes detected. Do work...
  //           //  console.log('after:'+after);
  //           //  console.log('before:'+before);
  //         },
  //         deep: true
  //     }
  // },
  watch: {
    'youtubeClose':function(v){
    //  console.log('marketingmethod youtubeClose');
    //  console.log(v);

      let _tmpYoutubeType = v.split('_');

    //  console.log('_tmpYoutubeType');
    //  console.log(_tmpYoutubeType);

    //  console.log(typeof this.view_youtube);
    //  console.log(this.view_youtube);

      if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
        if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'material'){
          this.view_youtube = false
        }
      }

    //  console.log(typeof this.view_youtube);
    //  console.log(this.view_youtube);
    },
    // <!-- 新手教學 -->
    guideStep(val) {
      if (val === 53) {
        this.posts_data();
      }

      if (val === 502) {
        this.adset_ads_data();
      }

      if (val == 57) {
      //  console.log('guideStep this.viewDatalistData.select_article');
      //  console.log(this.viewDatalistData.select_article);
        // this.showModal = false;
      }
    },
    // <!-- 新手教學 -->
    'viewDatalistData.creative_optimize':function(v){
    //  console.log('viewDatalistData.creative_optimize');
    //  console.log(v);
    //  console.log('this.goalsObjectiveData');
    //  console.log(this.goalsObjectiveData);
      // let select_article_length = this.viewDatalistData.select_article.length;
      // let delete_article_length = this.viewDatalistData.delete_article.length;
      // let select_creatives_length = this.viewDatalistData.select_creatives.length;
      // let delete_creatives_length = this.viewDatalistData.delete_creatives.length;
      // let select_creatives_adset_ads_length = this.viewDatalistData.select_creatives_adset_ads.length;
      // let delete_creatives_adset_ads_length = this.viewDatalistData.delete_creatives_adset_ads.length;

      // this.viewDatalistData.creative_optimize = false;

    //  console.log('this.viewDatalistData.creative_optimize');
    //  console.log(this.viewDatalistData.creative_optimize);
    },
    items (value){
    //  console.log('value');
    //  console.log(value);
      // console.log('b select_article');
      // console.log(this.viewDatalistData.select_article);
      // console.log('b prview_post_list');
      // console.log(this.prview_post_list);
      // console.log(this.prview);
      // this.viewDatalistData.select_article = value
    //  console.log('do items');

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.viewDatalistData.select_article) != 'undefined'){
        tmpSelectArticle = this.viewDatalistData.select_article;

        for (let i = 0; i < this.viewDatalistData.select_article.length; i++) {
          tmpSelectId.push(this.viewDatalistData.select_article[i].content);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          // console.log('i:');
          // console.log(value[i]);
          if(!tmpSelectId.includes(value[i].content)){
            tmpSelectArticle.push(value[i]);
            // console.log('this.prview['+value[i]+']');
            // console.log(this.prview[value[i]]);
            if(typeof this.prview[value[i].content] != 'undefined'){
              this.prview_post_list[value[i].content] = this.prview[value[i].content];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.viewDatalistData.select_article = tmpSelectArticle;
      // console.log('a select_article');
      // console.log(this.viewDatalistData.select_article);
      // console.log('a prview_post_list');
      // console.log(this.prview_post_list);
    },
    itemsDelete (value){
    //  console.log('value');
    //  console.log(value);
      // console.log('b delete_article');
      // console.log(this.viewDatalistData.delete_article);
      // console.log('b prview_post_list');
      // console.log(this.prview_post_list);
      // console.log(this.prview);
      // this.viewDatalistData.delete_article = value
    //  console.log('do itemsDelete');
    //  console.log(this.viewDatalistData.delete_article);

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.viewDatalistData.delete_article) != 'undefined'){
        tmpSelectArticle = this.viewDatalistData.delete_article;

        for (let i = 0; i < this.viewDatalistData.delete_article.length; i++) {
          tmpSelectId.push(this.viewDatalistData.delete_article[i].content);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);
      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          // console.log('i:');
          // console.log(value[i]);
          if(!tmpSelectId.includes(value[i].content)){
            tmpSelectArticle.push(value[i]);
            // console.log('this.prview['+value[i]+']');
            // console.log(this.prview[value[i]]);
            if(typeof this.prview[value[i].content] != 'undefined'){
              this.prview_post_list[value[i].content] = this.prview[value[i].content];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.viewDatalistData.delete_article = tmpSelectArticle;
      // console.log('a delete_article');
      // console.log(this.viewDatalistData.delete_article);
      // console.log('a prview_post_list');
      // console.log(this.prview_post_list);
    },
    creativesItems (value){
    //  console.log('value');
    //  console.log(value);
    //  console.log('b select_creatives');
    //  console.log(this.viewDatalistData.select_creatives);
    //  console.log('b prview_creatives_list');
    //  console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.viewDatalistData.select_creatives = value
    //  console.log('do creativesItems');

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.viewDatalistData.select_creatives) != 'undefined'){
        tmpSelectArticle = this.viewDatalistData.select_creatives;

        for (let i = 0; i < this.viewDatalistData.select_creatives.length; i++) {
          tmpSelectId.push(this.viewDatalistData.select_creatives[i].item_id);
        }
      }

    //  console.log('tmpSelectId');
    //  console.log(tmpSelectId);
    //  console.log('b tmpSelectArticle');
    //  console.log(tmpSelectArticle);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_creatives[value[i].item_id] != 'undefined'){
              this.prview_creatives_list[value[i].item_id] = this.prview_creatives[value[i].item_id];
            }
          } else {
            for(let j = 0; j < tmpSelectArticle.length; j++){
            //  console.log(j, tmpSelectArticle[j]);
              if(tmpSelectArticle[j].item_id == value[i].item_id){
                tmpSelectArticle.splice(j, 1);
              }
            }

            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_creatives[value[i].item_id] != 'undefined'){
              this.prview_creatives_list[value[i].item_id] = this.prview_creatives[value[i].item_id];
            }
          }
        }
      }

    //  console.log('a tmpSelectArticle');
    //  console.log(tmpSelectArticle);

      this.viewDatalistData.select_creatives = tmpSelectArticle;
    //  console.log('a select_creatives');
    //  console.log(this.viewDatalistData.select_creatives);
    //  console.log('a prview_creatives_list');
    //  console.log(this.prview_creatives_list);
    },
    creativesItemsDelete (value){
    //  console.log('value');
    //  console.log(value);
      // console.log('b delete_creatives');
      // console.log(this.viewDatalistData.delete_creatives);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.viewDatalistData.delete_creatives = value
    //  console.log('do creativesItemsDelete');
    //  console.log(this.viewDatalistData.delete_creatives);

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.viewDatalistData.delete_creatives) != 'undefined'){
        tmpSelectArticle = this.viewDatalistData.delete_creatives;

        for (let i = 0; i < this.viewDatalistData.delete_creatives.length; i++) {
          tmpSelectId.push(this.viewDatalistData.delete_creatives[i].item_id);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_creatives[value[i].item_id] != 'undefined'){
              this.prview_creatives_list[value[i].item_id] = this.prview_creatives[value[i].item_id];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.viewDatalistData.delete_creatives = tmpSelectArticle;
      // console.log('a delete_creatives');
      // console.log(this.viewDatalistData.delete_creatives);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    creativesMessageItems (value){
    //  console.log('value');
    //  console.log(value);
      // console.log('b select_creatives');
      // console.log(this.viewDatalistData.select_creatives);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.viewDatalistData.select_creatives = value
    //  console.log('do creativesMessageItems');

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.viewDatalistData.select_creatives_message) != 'undefined'){
        tmpSelectArticle = this.viewDatalistData.select_creatives_message;

        for (let i = 0; i < this.viewDatalistData.select_creatives_message.length; i++) {
          tmpSelectId.push(this.viewDatalistData.select_creatives_message[i].item_id);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);
      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_creatives_message[value[i].item_id] != 'undefined'){
              this.prview_creatives_message_list[value[i].item_id] = this.prview_creatives_message[value[i].item_id];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.viewDatalistData.select_creatives_message = tmpSelectArticle;
      // console.log('a select_creatives');
      // console.log(this.viewDatalistData.select_creatives);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    creativesMessageItemsDelete (value){
    //  console.log('value');
    //  console.log(value);
      // console.log('b delete_creatives');
      // console.log(this.viewDatalistData.delete_creatives);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.viewDatalistData.delete_creatives = value
    //  console.log('do creativesMessageItemsDelete');
    //  console.log(this.viewDatalistData.delete_creatives);

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.viewDatalistData.delete_creatives_message) != 'undefined'){
        tmpSelectArticle = this.viewDatalistData.delete_creatives_message;

        for (let i = 0; i < this.viewDatalistData.delete_creatives_message.length; i++) {
          tmpSelectId.push(this.viewDatalistData.delete_creatives_message[i].item_id);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_creatives_message[value[i].item_id] != 'undefined'){
              this.prview_creatives_message_list[value[i].item_id] = this.prview_creatives_message[value[i].item_id];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.viewDatalistData.delete_creatives_message = tmpSelectArticle;
      // console.log('a delete_creatives');
      // console.log(this.viewDatalistData.delete_creatives);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    creativesAdsetAdsMessageItems (value){
    //  console.log('value');
    //  console.log(value);
      // console.log('b select_creatives');
      // console.log(this.viewDatalistData.select_creatives);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.viewDatalistData.select_creatives = value
    //  console.log('do creativesAdsetAdsMessageItems');

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.viewDatalistData.select_creatives_adset_ads_message) != 'undefined'){
        tmpSelectArticle = this.viewDatalistData.select_creatives_adset_ads_message;

        for (let i = 0; i < this.viewDatalistData.select_creatives_adset_ads_message.length; i++) {
          tmpSelectId.push(this.viewDatalistData.select_creatives_adset_ads_message[i].item_id);
        }
      }

    //  console.log('tmpSelectId');
    //  console.log(tmpSelectId);
      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_adset_ads_message[value[i].item_id] != 'undefined'){
              this.prview_adset_ads_message_list[value[i].item_id] = this.prview_adset_ads_message[value[i].item_id];
            }
          }
        }
      }

    //  console.log('tmpSelectArticle');
    //  console.log(tmpSelectArticle);

      this.viewDatalistData.select_creatives_adset_ads_message = tmpSelectArticle;
      // console.log('a select_creatives');
      // console.log(this.viewDatalistData.select_creatives);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    creativesAdsetAdsMessageItemsDelete (value){
    //  console.log('value');
    //  console.log(value);
      // console.log('b delete_creatives');
      // console.log(this.viewDatalistData.delete_creatives);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.viewDatalistData.delete_creatives = value
    //  console.log('do creativesAdsetAdsMessageItemsDelete');
    //  console.log(this.viewDatalistData.delete_adset_ads_message);

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.viewDatalistData.delete_adset_ads_message) != 'undefined'){
        tmpSelectArticle = this.viewDatalistData.delete_adset_ads_message;

        for (let i = 0; i < this.viewDatalistData.delete_adset_ads_message.length; i++) {
          tmpSelectId.push(this.viewDatalistData.delete_adset_ads_message[i].item_id);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_adset_ads_message[value[i].item_id] != 'undefined'){
              this.prview_adset_ads_message_list[value[i].item_id] = this.prview_adset_ads_message[value[i].item_id];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.viewDatalistData.delete_adset_ads_message = tmpSelectArticle;
      // console.log('a delete_creatives');
      // console.log(this.viewDatalistData.delete_creatives);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    adsetAdsItems (value){
    //  console.log('value');
    //  console.log(value);
      // console.log('b select_creatives');
      // console.log(this.viewDatalistData.select_creatives);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.viewDatalistData.select_creatives = value
    //  console.log('do adsetAdsItems');

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.viewDatalistData.select_creatives_adset_ads) != 'undefined'){
        tmpSelectArticle = this.viewDatalistData.select_creatives_adset_ads;

        for (let i = 0; i < this.viewDatalistData.select_creatives_adset_ads.length; i++) {
          tmpSelectId.push(this.viewDatalistData.select_creatives_adset_ads[i].item_id);
        }
      }

    //  console.log('tmpSelectId');
    //  console.log(tmpSelectId);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_adset_ads[value[i].item_id] != 'undefined'){
              this.prview_adset_ads_list[value[i].item_id] = this.prview_adset_ads[value[i].item_id];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.viewDatalistData.select_creatives_adset_ads = tmpSelectArticle;
      // console.log('a select_creatives_adset_ads');
      // console.log(this.viewDatalistData.select_creatives_adset_ads);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    adsetAdsItemsDelete (value){
    //  console.log('value');
    //  console.log(value);
      // console.log('b delete_creatives_adset_ads');
      // console.log(this.viewDatalistData.delete_creatives_adset_ads);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.viewDatalistData.delete_creatives_adset_ads = value
    //  console.log('do adsetAdsItemsDelete');
    //  console.log(this.viewDatalistData.delete_creatives_adset_ads);

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.viewDatalistData.delete_creatives_adset_ads) != 'undefined'){
        tmpSelectArticle = this.viewDatalistData.delete_creatives_adset_ads;

        for (let i = 0; i < this.viewDatalistData.delete_creatives_adset_ads.length; i++) {
          tmpSelectId.push(this.viewDatalistData.delete_creatives_adset_ads[i].item_id);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_adset_ads[value[i].item_id] != 'undefined'){
              this.prview_adset_ads_list[value[i].item_id] = this.prview_adset_ads[value[i].item_id];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.viewDatalistData.delete_creatives_adset_ads = tmpSelectArticle;
      // console.log('a delete_creatives_adset_ads');
      // console.log(this.viewDatalistData.delete_creatives_adset_ads);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    'pageIdData' : function(v){
      ////  console.log('pageIdData:'+v);

      if(this.viewDatalistData.page_id != v){
        this.viewDatalistData.select_article = [];
        this.viewDatalistData.select_creatives = [];
        this.viewDatalistData.page_id = v
      }
    },
    'campaignIdData': function(v){
    //  console.log('campaignIdData:'+v);
    },
    'goalsObjectiveData': function(v){
    //  console.log('goalsObjectiveData:'+v);

      this.prview_now = null;
      this.prview_creatives_now = null;
      this.prview_creatives_message_now = null;
      this.prview_adset_ads_now = null;
    },
    'viewDatalistData.page_id': function(v){
      // console.log('material viewDatalistData.page_id:'+v);
    },
    'viewDatalistData.db_select_article': function(v){
    //  console.log('material viewDatalistData.db_select_article:'+v);
    //  console.log(this.viewDatalistData);

      if(v != '' && v != '[]'){
        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_fb_posts_form_db.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageIdData,
            special_ad_category: this.viewDatalistData.special_ad_category,
            tags: this.viewDatalistData.material_post_tags,
            tags_delete: this.viewDatalistData.material_post_delete_tags,
            form_da_posts: v
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
              // console.log('form db selected_click');
              // console.log(response.data.return_data);
              // console.log(response.data.return_prview);
              // this.items = response.data.return_data
              this.items = response.data.return_data
              this.itemsDelete = response.data.return_data_delete
              this.prview_post_list = response.data.return_prview
              // this.$emit('update:itemsDatalist', response.data.return_data)
              // this.$emit('update:prviewDatalist', response.data.return_prview)

              // console.log('campaign_form_fb_posts_form_db this.prview_post_list');
              // console.log(this.prview_post_list);
            }
          });
      }
    },
    'viewDatalistData.db_select_creatives': function(v){
    //  console.log('material viewDatalistData.db_select_creatives:'+v);

      if(v != '' && v != '[]' && typeof v != 'undefined'){
        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_fb_creatives_form_db.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageIdData,
            special_ad_category: this.viewDatalistData.special_ad_category,
            tags: this.viewDatalistData.material_creative_tags,
            tags_delete: this.viewDatalistData.material_creative_delete,
            form_da_posts: v
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
              // console.log('form db selected_click');
              // console.log(response.data.return_data);
              // console.log(response.data.return_prview);
              // this.items = response.data.return_data
              this.creativesItems = response.data.return_data
              this.creativesItemsDelete = response.data.return_data_delete
              this.prview_creatives_list = response.data.return_prview
              // this.$emit('update:itemsDatalist', response.data.return_data)
              // this.$emit('update:prviewDatalist', response.data.return_prview)

              for (let i = 0; i < this.creativesItems.length; i++) {
                if (this.creativesItems[i].status == 'N') {
                  if(this.campaign_objective != 'LEAD_GENERATION' && this.campaign_objective != 'MESSAGES'){
                  //  console.log('db_select_creatives');
                    this.$emit('childIsChangeData', true);
                  }
                }
              }

              // console.log('campaign_form_fb_creatives_form_db this.prview_creatives_list');
              // console.log(this.prview_creatives_list);
            }
          });
      }
    },
    'viewDatalistData.db_select_creatives_message': function(v){
    //  console.log('material viewDatalistData.db_select_creatives_message:'+v);

      if(v != '' && v != '[]' && typeof v != 'undefined'){
        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_fb_creatives_form_db.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageIdData,
            special_ad_category: this.viewDatalistData.special_ad_category,
            tags: this.viewDatalistData.material_creative_tags,
            tags_delete: this.viewDatalistData.material_creative_delete,
            form_da_posts: v
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
              // console.log('form db selected_click');
              // console.log(response.data.return_data);
              // console.log(response.data.return_prview);
              // this.items = response.data.return_data
              this.creativesMessageItems = response.data.return_data
              this.creativesMessageItemsDelete = response.data.return_data_delete
              this.prview_creatives_message_list = response.data.return_prview
              // this.$emit('update:itemsDatalist', response.data.return_data)
              // this.$emit('update:prviewDatalist', response.data.return_prview)

              for (let i = 0; i < this.creativesMessageItems.length; i++) {
                if (this.creativesMessageItems[i].status == 'N') {
                  if(this.campaign_objective != 'LEAD_GENERATION' && this.campaign_objective != 'MESSAGES'){
                  //  console.log('db_select_creatives_message');
                    this.$emit('childIsChangeData', true);
                  }
                }
              }

              // console.log('campaign_form_fb_creatives_form_db this.prview_creatives_list');
              // console.log(this.prview_creatives_list);
            }
          });
      }
    },
    'viewDatalistData.db_select_creatives_adset_ads_message': function(v){
    //  console.log('material viewDatalistData.db_select_creatives_adset_ads_message :'+v);

      if(v != '' && v != '[]' && typeof v != 'undefined'){
        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adset_ads_form_db.php', Qs.stringify({
            s_code: this.$route.params.id,
            tags: this.viewDatalistData.material_creative_tags,
            tags_delete: this.viewDatalistData.material_creative_delete_adset_ads,
            form_da_posts: v
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
              // console.log('form db selected_click');
              // console.log(response.data.return_data);
              // console.log(response.data.return_prview);
              // this.items = response.data.return_data
              this.creativesAdsetAdsMessageItems = response.data.return_data
              this.creativesAdsetAdsMessageItemsDelete = response.data.return_data_delete
              this.prview_adset_ads_message_list = response.data.return_prview
              // this.$emit('update:itemsDatalist', response.data.return_data)
              // this.$emit('update:prviewDatalist', response.data.return_prview)

              for (let i = 0; i < this.creativesAdsetAdsMessageItems.length; i++) {
                if (this.creativesAdsetAdsMessageItems[i].status == 'N') {
                  if(this.campaign_objective != 'LEAD_GENERATION' && this.campaign_objective != 'MESSAGES'){
                  //  console.log('db_select_creatives_adset_ads_message ');
                    this.$emit('childIsChangeData', true);
                  }
                }
              }

              // console.log('campaign_form_fb_creatives_form_db this.prview_creatives_list');
              // console.log(this.prview_creatives_list);
            }
          });
      }
    },
    'viewDatalistData.db_select_creatives_adset_ads': function(v){
    //  console.log('material viewDatalistData.db_select_creatives_adset_ads:'+v);
    //  console.log(this.viewDatalistData);

      if(v != '' && v != '[]' && typeof v != 'undefined'){
        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adset_ads_form_db.php', Qs.stringify({
            s_code: this.$route.params.id,
            tags: this.viewDatalistData.material_creative_tags,
            tags_delete: this.viewDatalistData.material_creative_delete_adset_ads,
            form_da_posts: v
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
            //  console.log('form db selected_click');
            //  console.log(response.data.return_data);
            //  console.log(response.data.return_prview);
              // this.items = response.data.return_data
              this.adsetAdsItems = response.data.return_data
              this.adsetAdsItemsDelete = response.data.return_data_delete
              this.prview_adset_ads_list = response.data.return_prview

              for (let i = 0; i < this.creativesItems.length; i++) {
                if (this.creativesItems[i].status == 'N') {
                  if(this.campaign_objective != 'LEAD_GENERATION' && this.campaign_objective != 'MESSAGES'){
                  //  console.log('db_select_creatives');
                    this.$emit('childIsChangeData', true);
                  }
                }
              }

              // console.log('campaign_form_fb_creatives_form_db this.prview_creatives_list');
              // console.log(this.prview_creatives_list);
            }
          });
      }
    },
  },
  methods: {
    onReady() {
    //  console.log('youtube');
      this.$refs.youtube.playVideo()
      // this.$refs.youtube.pauseVideo()
    },
    onStateChange(e){
    //  console.log(e);

      if(e.data == 0){
        this.view_youtube = false
      }
    },
    teachVideo(){
      this.$emit('checkClose')
      // let elem = document.getElementById('marketingMethod');
      // let positio = this.getPosition(elem);
      // console.log('x:'+positio.x);
      // console.log('y:'+positio.y);

      // this.x = positio.x + parseInt(80);
      // this.y = positio.y

      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;

      // console.log('windowWidth');
      // console.log(windowWidth);
      // console.log('windowHeight');
      // console.log(windowHeight);

      this.x = windowWidth - parseInt(390);
      this.y = windowHeight - parseInt(350);

      this.view_youtube = true;
      this.$emit('childYoutube', 'true_material')

      this.vars.start = 24
      this.vars.end = 171
    },
    getPosition(element) {
      let x = 0;
      let y = 0;

      while ( element ) {
        x += element.offsetLeft - element.scrollLeft + element.clientLeft;
        y += element.offsetTop - element.scrollLeft + element.clientTop;
        element = element.offsetParent;
      }

      return { x: x, y: y };
    },
    print(val) {
    //  console.log(val)
    },
    doDragging(){
    //  console.log('doDragging');
    },
    posts_data () {
      // console.log('pageId:'+this.pageId);
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        // this.showMaterialMyside = false;
        this.showModal = true

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_fb_posts.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageId,
            objective: this.goalsObjectiveData,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              // console.log('posts_data');
              // console.log(response.data.return_data);
              this.postsData = response.data.return_data

              // this.$emit('nextStep');
            }

            this.showList = true;
            // this.showMaterialMyside = true;
          });
      } else {
        Swal.fire(
                  this.lang['components']['Event']['Material']['methods']['posts_data']['no_pageId_swal_title'],
                  this.lang['components']['Event']['Material']['methods']['posts_data']['no_pageId_swal_text'],
                  'error'
                )
      }
    },
    creatives_data(){
      // console.log('creatives_data');
      // console.log('pageId:'+this.pageId);
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        this.showCreativeModal = true
        this.showMaterialMyside = false;
        this.showCreativeDialogMyside = false;

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_fb_creatives.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageId,
            objective: this.goalsObjectiveData,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              // console.log('posts_data');
              // console.log(response.data.return_data);
              this.creativesData = response.data.return_data
            }

            this.showMaterialMyside = true;
            this.showCreativeDialogMyside = true;
          });
      } else {
        Swal.fire(
                  this.lang['components']['Event']['Material']['methods']['creatives_data']['no_pageId_swal_title'],
                  this.lang['components']['Event']['Material']['methods']['creatives_data']['no_pageId_swal_text'],
                  'error'
                )
      }
    },
    adset_ads_data(){
      // console.log('creatives_data');
      // console.log('pageId:'+this.pageId);
      let adaccount_id = this.$route.params.adaccount_id;

      if(adaccount_id != 0 && adaccount_id != "" && adaccount_id != null && typeof adaccount_id != 'undefined'){
        this.showMaterialMyside = false;
        this.showAdsetAdsModal = true;

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adaccount_campaigns.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: adaccount_id,
            objective: this.goalsObjectiveData,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
            //  console.log('adset_ads_data');
            //  console.log(response.data.return_data.adaccount_campaigns_list);
              this.adaccountCampaignsData = response.data.return_data.adaccount_campaigns_list
            }

            this.showMaterialMyside = true;
          });
      } else {
        Swal.fire(
                  this.lang['components']['Event']['Material']['methods']['adset_ads_data']['no_pageId_swal_title'],
                  this.lang['components']['Event']['Material']['methods']['adset_ads_data']['no_pageId_swal_text'],
                  'error'
                )
      }
    },
    remove_list (index){
      for (let i = 0; i < this.viewDatalistData.select_article.length; i++) {
        if (i == index) {
          this.viewDatalistData.select_article.splice(i, 1);

        //  console.log('remove_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_delete_list (index){
      for (let i = 0; i < this.viewDatalistData.delete_article.length; i++) {
        if (i == index) {
          this.viewDatalistData.delete_article.splice(i, 1);

        //  console.log('remove_delete_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    back_item(index){
      for (let i = 0; i < this.viewDatalistData.delete_article.length; i++) {
        if (i == index) {
          // this.viewDatalistData.select_article.splice(i, 1);
          this.viewDatalistData.delete_article[i].tagType = 1;

        //  console.log('back_item 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_creatives_list(index){
      for (let i = 0; i < this.viewDatalistData.select_creatives.length; i++) {
        if (i == index) {
          this.viewDatalistData.select_creatives.splice(i, 1);

        //  console.log('remove_creatives_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    edit_creatives_list(index){
    //  console.log('edit_creatives_list');
    //  console.log(index);
    //  console.log(this.viewDatalistData.select_creatives);
    //  console.log(this.viewDatalistData.select_creatives[index]);

      this.editCreativeId = this.viewDatalistData.select_creatives[index].item_id;
      this.showEditModal = true;
    },
    remove_delete_creatives_list(index){
      for (let i = 0; i < this.viewDatalistData.delete_creatives.length; i++) {
        if (i == index) {
          this.viewDatalistData.delete_creatives.splice(i, 1);

        //  console.log('remove_delete_creatives_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    back_creatives_item(index){
      for (let i = 0; i < this.viewDatalistData.delete_creatives.length; i++) {
        if (i == index) {
          // this.viewDatalistData.select_article.splice(i, 1);
          this.viewDatalistData.delete_creatives[i].tagType = 1;

        //  console.log('back_creatives_item 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    edit_creatives_message_list(index){
    //  console.log('edit_creatives_message_list');
    //  console.log(index);
    //  console.log(this.viewDatalistData.select_creatives_message);
    //  console.log(this.viewDatalistData.select_creatives_message[index]);

      this.editCreativeId = this.viewDatalistData.select_creatives_message[index].item_id;
      this.showEditModal = true;
    },
    remove_creatives_message_list(index){
      for (let i = 0; i < this.viewDatalistData.select_creatives_message.length; i++) {
        if (i == index) {
          this.viewDatalistData.select_creatives_message.splice(i, 1);

        //  console.log('remove_creatives_message_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_delete_creatives_message_list(index){
      for (let i = 0; i < this.viewDatalistData.delete_creatives_message.length; i++) {
        if (i == index) {
          this.viewDatalistData.delete_creatives_message.splice(i, 1);

        //  console.log('remove_delete_creatives_message_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    back_creatives_message_item(index){
      for (let i = 0; i < this.viewDatalistData.delete_creatives_message.length; i++) {
        if (i == index) {
          // this.viewDatalistData.select_article.splice(i, 1);
          this.viewDatalistData.delete_creatives_message[i].tagType = 1;

        //  console.log('back_creatives_message_item 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_adset_ads_message_list(index){
      for (let i = 0; i < this.viewDatalistData.select_creatives_adset_ads_message.length; i++) {
        if (i == index) {
          this.viewDatalistData.select_creatives_adset_ads_message.splice(i, 1);

        //  console.log('remove_adset_ads_message_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_delete_adset_ads_message_list(index){
      for (let i = 0; i < this.viewDatalistData.delete_adset_ads_message.length; i++) {
        if (i == index) {
          this.viewDatalistData.delete_adset_ads_message.splice(i, 1);

        //  console.log('remove_delete_adset_ads_message_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    back_adset_ads_message_item(index){
      for (let i = 0; i < this.viewDatalistData.delete_adset_ads_message.length; i++) {
        if (i == index) {
          // this.viewDatalistData.select_article.splice(i, 1);
          this.viewDatalistData.delete_adset_ads_message[i].tagType = 1;

        //  console.log('back_creatives_message_item 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_adset_ads_list(index){
      for (let i = 0; i < this.viewDatalistData.select_creatives_adset_ads.length; i++) {
        if (i == index) {
          this.viewDatalistData.select_creatives_adset_ads.splice(i, 1);

        //  console.log('remove_adset_ads_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_delete_adset_ads_list(index){
      for (let i = 0; i < this.viewDatalistData.delete_creatives_adset_ads.length; i++) {
        if (i == index) {
          this.viewDatalistData.delete_creatives_adset_ads.splice(i, 1);

        //  console.log('remove_delete_adset_ads_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    back_adset_ads_item(index){
      for (let i = 0; i < this.viewDatalistData.delete_creatives_adset_ads.length; i++) {
        if (i == index) {
          // this.viewDatalistData.select_article.splice(i, 1);
          this.viewDatalistData.delete_creatives_adset_ads[i].tagType = 1;

        //  console.log('back_adset_ads_item 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    prview_focus (index){
      this.prview_creatives_now = null;
      this.prview_creatives_message_now = null;
      this.prview_adset_ads_message_now = null;
      this.prview_adset_ads_now = null;
      // console.log('prview_focus');
      // console.log(index);
      // console.log(this.prview_post_list);
      this.prview_now = this.prview_post_list[index]
    },
    prview_creatives_focus (index){
      this.prview_now = null;
      this.prview_creatives_message_now = null;
      this.prview_adset_ads_message_now = null;
      this.prview_adset_ads_now = null;
      // console.log('prview_creatives_focus');
      // console.log(index);
      // console.log(this.prview_creatives_list);
      this.prview_creatives_now = this.prview_creatives_list[index]
    },
    prview_creatives_message_focus (index){
      this.prview_now = null;
      this.prview_creatives_now = null;
      this.prview_adset_ads_message_now = null;
      this.prview_adset_ads_now = null;
      // console.log('prview_creatives_focus');
      // console.log(index);
      // console.log(this.prview_creatives_list);
      this.prview_creatives_message_now = this.prview_creatives_message_list[index]
    },
    prview_adset_ads_message_focus (index){
      this.prview_now = null;
      this.prview_creatives_now = null;
      this.prview_creatives_message_now = null;
      this.prview_adset_ads_now = null;
      // console.log('prview_creatives_focus');
      // console.log(index);
      // console.log(this.prview_creatives_list);
      this.prview_adset_ads_message_now = this.prview_adset_ads_message_list[index]
    },
    prview_adset_ads_focus (index){
      this.prview_now = null;
      this.prview_creatives_now = null;
      this.prview_creatives_message_now = null;
      this.prview_adset_ads_message_now = null;
      // console.log('prview_adset_ads_focus');
      // console.log(index);
      // console.log(this.prview_adset_ads_list);
      this.prview_adset_ads_now = this.prview_adset_ads_list[index]
    },
    materialGetData(){
    //  console.log('從組件知道有修改 materialGetData');
      this.$emit('childIsChangeData', true);
    },
    emptyStep(value){
    //  console.log('組件裡的 emptyStep');
    //  console.log(value);
      this.$emit('emptyStep', value);
    },
    materialCreativesGetData(){
    //  console.log('從組件知道有修改 materialCreativesGetData');
      this.$emit('childIsChangeData', true);
    },
    materialAdsetAdsGetData(){
    //  console.log('從組件知道有修改 materialAdsetAdsGetData');
      this.$emit('childIsChangeData', true);
    },
    add_test(){
      // console.log('add_test');
      // console.log(this.showAddModal);
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        this.showAddModal = true
      } else {
        Swal.fire(
                  this.lang['components']['Event']['Material']['methods']['add_test']['no_pageId_swal_title'],
                  this.lang['components']['Event']['Material']['methods']['add_test']['no_pageId_swal_text'],
                  'error'
                )
      }
      // console.log(this.showAddModal);
    },
    scroll_messages(){
    //  console.log('scroll_messages');

      var todayForm = new Date();
      var yearForm = todayForm.getFullYear();
      var dateForm = String(todayForm.getDate()).padStart(2, '0');
      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      todayForm = yearForm + monthForm + dateForm + timeForm;

    //  console.log('1_'+todayForm);

      this.$emit('childActiveScroll', '1_'+todayForm);
    }
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    viewDatalistData: {
      get: function () {
        return this.viewDatalist
      },
      set: function (value) {
        this.$emit('update:viewDatalistData', value)
      },
    },
    pageIdData: {
      get: function () {
        return this.pageId
      },
      set: function (value) {
        this.$emit('update:pageIdData', value)
      },
    },
    campaignIdData: {
      get: function () {
        return this.campaignId
      },
      set: function (value) {
        this.$emit('update:campaignIdData', value)
      },
    },
    goalsObjectiveData: {
      get: function () {
        return this.goalsObjective
      },
      set: function (value) {
        this.$emit('update:goalsObjectiveData', value)
      },
    }
  }
};
</script>

<style lang="scss" scoped>
  .status-n {
    background-color:#E6F7DD;
  }
</style>
